/* eslint-disable no-underscore-dangle */
import { useEffect, useContext } from 'react';

import { useMutation } from '@apollo/client';

import { GeneralContext } from '../../../../core/app-context/GeneralContext';
import { DELETE_CREDENTIALS_VTEX } from './graphql';

export function useDeleteVtexCredentials() {
  const { setLoading, setErrorMessage, setSuccessMessage } =
    useContext(GeneralContext);
  const [DeleteVtexCredentials, { loading }] = useMutation(
    DELETE_CREDENTIALS_VTEX,
    { fetchPolicy: 'network-only' },
  );

  useEffect(() => {
    setLoading(loading);
  }, [loading]);

  async function deleteVtexCredentials(storeId) {
    try {
      const res = await DeleteVtexCredentials({
        variables: { storeId },
      });
      const { code, message } = res.data.deleteVtexCredentials;
      if (code === 200) {
        setSuccessMessage(message);
      } else {
        setErrorMessage(message);
      }
    } catch (e) {
      setErrorMessage(
        'Não foi possível deleter as credenciais Vtex, tente novamente mais tarde.',
      );
    }
  }

  return {
    deleteVtexCredentials,
    loading,
  };
}
